import axios from "axios";
import newPdf from "../LeadSlide/Pdf/NewPdf";
import ExampleBlocks from "../LeadSlide/Pdf/ExampleBlocks";
import TinyMceConfig from "../LeadSlide/Pdf/TinyMceConfig";
import PdfElements from "../LeadSlide/Pdf/PdfElements";
import {aiRules as aiConfig} from "./ai";

const state = {
    pdf: {
        name: "",
        file: null,
        pages: []
    },
    pdfs: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    loading: false,
    element_options: {
        display: false,
        pageIndex: null,
        elements: PdfElements
    },
    example_blocks: ExampleBlocks,
    element: {
        display: false,
        json: {}
    },
    block_settings: {
        display: false,
    },
    search_pdf: {
        display: false,
        value: '',
        item: {},
        selectedPdf: '',
        results: []
    },
    history: {
        items: [
            // stores the pdf history
        ],
        // The current index of the history used to undo/redo
        index: 0,
    },
    pdfEditorConfig: TinyMceConfig,
    element_permissions: {
        max_height: 1090,
        permissions: [],
    },
    typing: false,
}

const actions = {
    deleteBlock: (store, payload) => {
        store.commit('deleteBlock', payload);
    },
    updateBlockSettings: (store, payload) => {
        store.commit('setBlockSettings', payload);
    },
    changePdfElementOptions: (store, payload) => {
        store.commit('changePdfElementOptions', payload);
    },
    changePdfElement: (store, payload) => {
        store.commit('changePdfElement', payload);
    },
    setPage: (store, payload) => {
        store.commit('setElementPageIndex', payload);
    },
    editPdf: (store, payload) => {
        store.commit('setPdf', payload);
    },
    addPdfElement: (store, payload) => {
        store.commit('addPdfElement', payload)
    },
    addPage: (store, payload) => {
        store.commit('addPage')
    },
    removePage: (store, payload) => {
        store.commit('removePage', payload)
    },
    updateSearchPdfModal: (store, payload) => {
        store.commit('updateSearchPdfModal', payload);
    },
    searchPdf: (store, payload) => {

        axios.get('/business/pdfs/?name=' + payload + '&limit=15').then(function (res) {

            store.commit('setPdfSearchResults', res.data.results);

        }).catch(function (err) {
            console.log('error searching for pdfs')
        }).finally(function () {
        });
    },
    loadPdfs: (store, payload) => {
        store.commit('setPdfLoading', true);
        axios.get('/business/pdfs/').then(function (res) {
            store.commit('setPdfs', res.data);
        }).catch(function (err) {
            console.log('error loading pdfs')
        }).finally(function () {
            store.commit('setPdfLoading', false);
        });
    },
    savePdf: (store, payload) => {
        return new Promise((resolve, reject) => {
            let url = '/business/pdfs/';
            if (payload.id) {
                url += payload.id + '/';
                axios.put(url, payload).then(function (res) {
                    return resolve(res.data)
                }).catch(function (err) {
                    console.log('error loading pdfs')
                    return reject(err)
                })
            } else {
                axios.post(url, payload).then(function (res) {
                    store.commit('setID', res.data.id)
                    return resolve(
                        res
                    )
                }).catch(function (err) {
                    console.log('error loading pdfs')
                    return reject(err)
                })
            }

        })

    },
    deletePdf: (store, payload) => {
        return new Promise((resolve, reject) => {
            let url = '/business/pdfs/' + payload.id + '/';
            axios.delete(url).then(function (res) {
                return resolve(res.data)
            }).catch(function (err) {
                console.log('error loading pdfs')
                return reject(err)
            }).finally(function () {
                store.commit('setPdfLoading', false);
            });
        });
    },
    aiPdf: (store, purpose) => {
        const aiPayload = [

            {
                type: 'purpose',
                text: purpose
            },
            aiConfig.title,
            aiConfig.subtitle,
            aiConfig.introHeading,
            aiConfig.intro,
            aiConfig.title,
            aiConfig.subtitle,
            aiConfig.paragraph,
            aiConfig.paragraph,
        ];
        store.commit('setPdfLoading', true);


        return new Promise((resolve, reject) => {
            axios.post('business/generate-text', aiPayload)
                .then(response => {

                    const options = response.data.result;
                    const mutatePayload = {
                        options: options,
                        block: {},
                    }
                    let time = store.commit('aiPdfMutation', mutatePayload);
                    return resolve(time);
                })
                .catch(error => {
                    return reject(error);
                }).finally(() => {
                    store.commit('setPdfLoading', false);
            });
        });
    },
    newPdf: (store, aiDetails) => {
        return new Promise((resolve, reject) => {

            /**
             * Set the default pdf, remove tje added page and set default values to blank
             * @type {{pages: [{blocks: [{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}}], order: number},{blocks: [{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}}], order: number},{blocks: [{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}},{typeSettings: {verticalAlign: boolean, spacing: number, fontFamily: string, color: string, fontSize: string, bold: boolean, value: string}, generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, backgroundSettings: {overlayValue: string, overlay: boolean, fixed: boolean, type: string, float: string, value: string, height: string}},{generalSettings: {padding: {top: number, left: number, bottom: number, right: number}, margin: {top: number, left: number, bottom: number, right: number}, type: string}, type: string, imageSettings: {value: string, height: number}, backgroundSettings: {verticalAlign: boolean, overlayValue: string, overlay: boolean, type: string, float: string, value: string, height: string}}], order: number}], name: string, id: null}}
             */
            let pdf = JSON.parse(newPdf);

            if(aiDetails.loadAi) {
                pdf.pages[0].blocks[0].typeSettings.value = "";
                pdf.pages[0].blocks[1].typeSettings.value = "";
                pdf.pages[0].blocks[2].typeSettings.value = "";
                pdf.pages[1].blocks[0].typeSettings.value = "";
                pdf.pages[1].blocks[1].typeSettings.value = "";
                pdf.pages[1].blocks[2].typeSettings.value = "";
                pdf.pages.splice(2, 1);
            }
            pdf.loadAi = aiDetails.loadAi;
            pdf.purpose = aiDetails.purpose;

            store.commit('setPdf', pdf);
            return resolve(
                pdf
            );
        });

    },
    generatePdf: (store, payload) => {
        return new Promise((resolve, reject) => {
            axios.get('/business/download-pdf/' + payload.id).then(function (r) {
                return resolve(
                    store.commit('setFile', r.data)
                );
            }).catch(function (err) {
                return reject(err);
            })
        })
    },
    changePdfLoadingStatus: (store, payload) => {
        store.commit('setPdfLoading', payload);
    },
    addPdfHistory: (store, payload) => {
        store.commit('setHistory', payload);
    },
    undoPdf: (store, payload) => {
        // commit undoPdf
        store.commit('undoPdf', payload);
    },
    redoPdf: (store, payload) => {
        store.commit('redoPdf', payload);
    },
    setPdfElementPermissions: (store, payload) => {
        store.commit('setPdfElementPermissions', payload);
    }
}

const getters = {
    pdfTyping: state => {
        return state.typing;
    },
    pdfElementPermissions: state => {
        return state.element_permissions;
    },
    pdf: state => {
        return state.pdf
    },
    pdfs: state => {
        return state.pdfs
    },
    pdfElement: state => {
        return state.element;
    },
    pdfElementOptions: state => {
        return state.element_options;
    },
    pdfLoading: state => {
        return state.loading
    },
    pdfBlockSettings: state => {
        return state.block_settings;
    },
    pdfSearchModal: state => {
        return state.search_pdf;
    },
    canUndo: state => {
        return state.history.index > 0;
    },
    canRedo: state => {
        return state.history.index + 1 < state.history.items.length;
    },
    pdfEditorConfig: state => {
        return state.pdfEditorConfig;
    }
}

const generate_individual_pdf_payload = (state, payload) => {

    state.typing = true;
    let new_line_html = "";

    payload.options.forEach(function (option) {
        const replacementText = option.text;
        let tag_searches = []
        switch(option.type) {
            case 'title':
                tag_searches.push(
                    ...[
                        'h1',
                        'h2',
                        'p'
                    ]
                )
                break;
            case 'subtitle':
                tag_searches.push(
                    ...[
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'p'
                    ]
                )
                break;
            default:
                tag_searches.push('p')
                break;
        }

        let parser = new DOMParser();
        let doc = parser.parseFromString(payload.block.typeSettings.value, "text/html");
        let added_content = false;
        for (let tag of tag_searches) {
            if(added_content) {
                // skip as content already added.
                continue
            }
            // Try to select an element with the current tag name
            let element = doc.querySelector(tag);
            // If an element was found
            if (element) {
                let span = element.querySelector("span");
                if (span) {
                    // If a span was found, copy its class and style
                    let spanClass = span.className;
                    let spanStyle = span.getAttribute('style');

                    // Create a new span with the same class and style, and your new content
                    let newSpan = doc.createElement('span');
                    newSpan.className = spanClass;
                    newSpan.setAttribute('style', spanStyle);
                    newSpan.innerHTML = replacementText;

                    // Replace the original element's inner HTML with the new span
                    element.innerHTML = '';
                    element.appendChild(newSpan);
                    new_line_html += doc.body.innerHTML;
                } else {
                    element.innerHTML = replacementText;
                    new_line_html += element.outerHTML;
                }
                added_content = true;
                break;
            } else {
                console.log(
                    `No element found with tag name ${tag} for type ${option.type} and text ${option.text}`
                )

                const is_heading = option.type === 'title';
                // if new_line_html does not contain replacementText
                new_line_html += get_formatted_line(replacementText, false, false, is_heading);
                added_content = true;
            }
        }
    });
    state.pdf.pages[payload.page_index].blocks[payload.block_index].typeSettings.value = "";
    write_text(state, 30, new_line_html, payload.page_index, payload.block_index,  0, true);

    return false;
}

const check_page = (state, page_index) => {
    while(typeof state.pdf.pages[page_index] === 'undefined') {
        add_new_page(state);
    }

}
const write_text = (state, init_delay, text, page_index, block_index, cumulative_delay = 0, final_write=false) => {
    let totalDelay = cumulative_delay;
    check_page(state, page_index);

    for (let i = 0; i < text.length; i++) {
        const delay = totalDelay + init_delay;
        setTimeout(() => {
            state.pdf.pages[page_index].blocks[block_index].typeSettings.value += text[i];
            if(final_write && i === text.length - 1) {
                state.typing = false;
                localStorage.setItem('pdf', JSON.stringify(state.pdf));
            }
        }, delay);
        totalDelay += init_delay;
    }
    return totalDelay;
}

const add_new_page = (state) => {
    console.log("Add a new page");
    state.pdf.pages.push(
        {
            order: 3,
            blocks: [
                {
                    type: 'text',
                    generalSettings: {
                        padding: {
                            top: 0,
                            bottom: 0,
                            right: 5,
                            left: 5,
                        },
                        margin: {
                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: 0,
                        },
                        type: "text"
                    },
                    typeSettings: {
                        fontSize: '45px',
                        color: '#000000',
                        bold: false,
                        value: '',
                        spacing: 0,
                        fontFamily: '',
                        verticalAlign: true
                    },
                    backgroundSettings: {
                        type: 'color',
                        value: 'rgba(0, 253, 255, 1)',
                        fixed: false,
                        overlay: false,
                        overlayValue: 'rgba(0, 0, 0, 0.4)',
                        height: '200px',
                    },
                },
                {
                    type: 'text',
                    generalSettings: {
                        padding: {
                            top: 0,
                            bottom: 0,
                            right: 12,
                            left: 12,
                        },
                        margin: {
                            top: 12,
                            bottom: 4,
                            right: 0,
                            left: 0,
                        },
                        type: "text"
                    },
                    typeSettings: {
                        color: '#000000',
                        bold: false,
                        value: '',
                        spacing: 0,
                        fontFamily: '',
                        verticalAlign: false
                    },
                    backgroundSettings: {
                        type: 'none',
                        value: '/media/preload/outdoor/benjamin-voros-phIFdC6lA4E-unsplash.jpg',
                        fixed: false,
                        overlay: false,
                        float: 'none',
                        overlayValue: 'rgba(0, 0, 0, 0.4)',
                        height: 'auto',
                    },
                },
                {
                    type: 'text',
                    generalSettings: {
                        padding: {
                            top: 0,
                            bottom: 0,
                            right: 12,
                            left: 12,
                        },
                        margin: {
                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: 0,
                        },
                        type: "text"
                    },
                    typeSettings: {
                        fontSize: '45px',
                        color: '#000000',
                        bold: false,
                        value: '',
                        spacing: 0,
                        fontFamily: '',
                        verticalAlign: false
                    },
                    backgroundSettings: {
                        type: 'none',
                        value: '/media/preload/outdoor/benjamin-voros-phIFdC6lA4E-unsplash.jpg',
                        fixed: false,
                        overlay: false,
                        float: 'none',
                        overlayValue: 'rgba(0, 0, 0, 0.4)',
                        height: 'auto',
                    },
                },
            ]
        },
    )
}
const get_formatted_line = (line_text, is_banner_text=false, is_banner_subtitle=false, is_heading=false) => {
    const title_limit = 65;
    let body_text;

    if(is_banner_text) {
        return `<h1 class="text-h2 text-sm-h1" style="text-align:center;"><span style="color:#FFFFFF;font-family:'Open Sans', sans-serif;">${line_text}</span></h1>`;
    }

    if(is_heading) {
        return `<h1 class="text-h2 text-sm-h1" style="text-align: center;" data-mce-style="text-align: center;"><span style="color: rgb(255, 255, 255);" data-mce-style="color: #ffffff;"><strong><span style="font-family: Open Sans, sans-serif; font-size: 45px;" data-mce-style="font-family: Open Sans, sans-serif; font-size: 45px;">${line_text.toUpperCase()}</span></strong></span></h1>`;
    }

    if((line_text.length < title_limit) && !is_banner_subtitle) {
        return `<h4 class="display-1" style="text-align: left;" data-mce-style="text-align: center;"><span style="font-family: Open Sans, sans-serif; font-size: 24pt; font-weight:800;" data-mce-style="font-family: Open Sans, sans-serif; font-size: 24pt;">${line_text}</span></h4>`;
    }

    if(is_banner_subtitle)
    {
        body_text = `<p class="body-1" style="text-align: center;"><span style="font-family: Open Sans, sans-serif; color: #FFFFFF;"><strong>${line_text}</strong></span></p>`;
    } else {
        if (line_text.includes(':')) {
            let parts = line_text.split(':');
            let title = parts[0].trim();
            let content = parts[1].trim();
            body_text = `<p class="body-1"><span style="font-family: Open Sans, sans-serif;"><strong>${title}:</strong> ${content}</span></p>`;
        } else {
            body_text = `<p class="body-1"><span style="font-family: Open Sans, sans-serif;">${line_text}</span></p>`;
        }
    }

    return body_text;
}
const generate_full_pdf_payload = (state, payload) => {
    const returned_ai_text = payload.options.filter(function(item) {
        // Remove any empty text
        return item.text !== "";
    });
    // splice any state.pdf.pages[2]
    state.pdf.pages.splice(2, 1);
    const banner_block_text = get_formatted_line(returned_ai_text[0].text, true) + get_formatted_line(returned_ai_text[1].text, false, true);
    const intro_heading_text = get_formatted_line(returned_ai_text[2].text)
    const intro_text = get_formatted_line(returned_ai_text[3].text);
    const chapter_title_text = get_formatted_line(returned_ai_text[4].text, false, false, true);
    const chapter_subtitle_text = get_formatted_line(returned_ai_text[5].text);
    let chapter_text = get_formatted_line(returned_ai_text[6].text) + get_formatted_line(returned_ai_text[7].text);

    let page_three_title = "";
    let page_three_subtitle = "";
    let page_three_chapter_text = "";

    const page_char_limit = 1100;
    let current_char_count = (returned_ai_text[6].text + ' ' + returned_ai_text[7].text).length;
    let current_page = 2;

    if(returned_ai_text.length >= 8) {
        for(let i = 8; i < returned_ai_text.length; i++) {
            /**
             * If more than 8 lines returned
             * go through additional lines and assign a type
             */
            const line_text = returned_ai_text[i].text;
            if (!line_text || line_text === '') {
                continue;
            }

            const words = line_text.split(' ');
            if(current_char_count + line_text.length <= page_char_limit) {
                chapter_text += get_formatted_line(line_text);
                current_char_count += line_text.length;
                continue;
            }
            if(current_page === 2) {
                // first line of new page
                if(words.length < 4) {
                    // First line is a heading as it's a new page
                    page_three_title += get_formatted_line(line_text, false, false, true);
                } else {
                    page_three_title += get_formatted_line("Unknown", false, false, true);
                    page_three_chapter_text += get_formatted_line(line_text);
                }
                current_page += 1;
            } else {
                if(page_three_chapter_text === "") {
                    page_three_subtitle = get_formatted_line(line_text);
                } else {
                    page_three_chapter_text = get_formatted_line(line_text);
                }
            }
            current_char_count += line_text.length;
        }

    }

    const delayPerChar = 3;
    // const has_more_pages = state.pdf.pages.length > 2;
    const has_more_pages = true;

    let cumulativeDelay = write_text(state, delayPerChar, banner_block_text, 0, 0, 0);
    cumulativeDelay = write_text(state, delayPerChar, intro_heading_text, 0, 1,  cumulativeDelay);
    cumulativeDelay = write_text(state, delayPerChar, intro_text, 0, 2, cumulativeDelay)
    cumulativeDelay = write_text(state, delayPerChar, chapter_title_text, 1, 0, cumulativeDelay)
    cumulativeDelay = write_text(state, delayPerChar, chapter_subtitle_text, 1, 1, cumulativeDelay)
    cumulativeDelay = write_text(state, delayPerChar, chapter_text, 1, 2, cumulativeDelay, !has_more_pages);

    if(has_more_pages) {
        cumulativeDelay = write_text(state, delayPerChar, page_three_title, 2, 0, cumulativeDelay)
        cumulativeDelay = write_text(state, delayPerChar, page_three_subtitle, 2, 1, cumulativeDelay)
        cumulativeDelay = write_text(state, delayPerChar, page_three_chapter_text, 2, 2, cumulativeDelay, true);
    }

    return cumulativeDelay;
}

const mutations = {
    aiPdfMutation: (state, payload) => {
        let isAiLoad = state.pdf.loadAi;
        state.pdf.purpose = null;
        state.pdf.loadAi = false;
        state.typing = true;

        if(payload.block_index > -1 && payload.page_index > -1) {
            return generate_individual_pdf_payload(state, payload);

        } else {
            return generate_full_pdf_payload(state, payload);
        }


    },
    setPdfElementPermissions: (state, payload) => {
        state.element_permissions.permissions = payload;
    },
    setID: (state, payload) => {
        state.pdf.id = payload;
    },
    setPdf: (state, payload) => {
        state.pdf = payload;

        // set current pdf from history.items[index]
        state.history.items = [JSON.stringify(state.pdf)];
        localStorage.setItem('pdf', JSON.stringify(state.pdf));
        state.loading = false;
    },
    setPdfs: (state, payload) => {
        state.pdfs = payload;
    },
    setPdfLoading: (state, payload) => {
        state.loading = payload;
    },
    setElementPageIndex: (state, payload) => {
        state.element_options.pageIndex = payload;
        state.element_options.display = true;
    },
    changePdfElement: (state, payload) => {
        state.element_options[payload.key] = payload.value;
    },
    setBlockSettings: (state, payload) => {
        let page = state.pdf.pages[payload.pageIndex];
        let block = null;


        if (page) {
            block = page.blocks[payload.blockIndex];
            state.block_settings.block = block;
        }

        state.block_settings = {
            ...state.block_settings,
            ...payload,
        }
    },
    changePdfElementOptions: (state, payload) => {
        state.element_options[payload.key] = payload.value;
    },
    addPdfElement: (state, payload) => {
        state.pdf.pages[payload.index].blocks.push(JSON.parse(payload.element));
        state.element_options.display = false;
    },
    addPage: (state) => {
        state.pdf.pages.push({
            order: state.pdf.pages.length + 1,
            blocks: []
        })
    },
    removePage: (state, payload) => {
        state.pdf.pages.splice(payload.index, 1);
    },
    setFile: (state, payload) => {
        return state.file = payload.file
    },
    deleteBlock: (state, payload) => {
        /**
         * payload = {
         * pageIndex: 0,
         * blockIndex: 0,
         * }
         */
        state.pdf.pages[payload.pageIndex].blocks.splice(payload.blockIndex, 1);
    },
    updatePdf: (state, payload) => {

    },
    updatePdfs: (state, payload) => {

    },
    removePdf: (state, payload) => {

    },
    setPdfSearchResults: (state, payload) => {
        state.search_pdf.results = payload;
    },
    updateSearchPdfModal: (state, payload) => {
        /**
         * payload = {
         * display: 'false',
         * }
         */
        if ((payload.selectedPdf !== state.search_pdf.selectedPdf) && payload.selectedPdf !== '') {
            /**
             * PDF selected change the item href
             */
            // let file = payload.selectedPdf.file;
            // if (file[0] !== '/') {
            //     file = '/' + file;
            // }
            state.search_pdf.item.href = payload.selectedPdf.download_link;
        }

        state.search_pdf = {
            ...state.search_pdf,
            ...payload
        }
    },
    setHistory: (state, payload) => {
        /**
         * changes the current history index to latest
         * and pushes the new state to the history stack
         */
        state.history.items.push(
            JSON.stringify(payload)
        );
        state.history.index = state.history.items.length;
    },
    setTyping: (state, bool) => {
        state.typing = bool;
    },
    undoPdf: (state, payload) => {
        state.loading = true;
        // check if index - 1 exists
        let minus_amount = state.history.index === 2 ? 2:1;
        console.log(state.history.index);
        if (state.history.items[state.history.index - minus_amount]) {
            // set the current index of the undo stack as -1
            state.history.index = state.history.index - minus_amount;
            state.pdf = JSON.parse(state.history.items[state.history.index]);
            console.log(state.pdf);
        }
        state.loading = false;
    },
    redoPdf: (state, payload) => {
        state.loading = true;

        // check if a history item exists at the current index + 1
        if (state.history.items[state.history.index + 1]) {
            // set the current index of the undo stack as +1
            state.history.index = state.history.index + 1;
            // set current pdf from history.items[index]
            state.pdf = JSON.parse(state.history.items[state.history.index]);
        }
        state.loading = false;
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}